import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ApiHelper } from '../helpers/home-api.helper';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { PolicyService } from './policy.service';

@Injectable()
export class DownloadService {

    constructor(private apiHelper: ApiHelper,
        private http: HttpClient,
        private policyService: PolicyService) { }

    download(url = '', fileName = 'doc.pdf', type = 'application/pdf', overrideHeaders = {}) {

        return new Observable(observer => {

            const defaultHeaders = {
                'Content-Type': 'application/stream',
                'x-authorization': localStorage.getItem('tk'),
                'x-branchOffice': localStorage.getItem('branchOffice')
            };

            const requestHeaders = { ...defaultHeaders, ...overrideHeaders };

            this.apiHelper.getWithoutResponse(url, null, requestHeaders, 'blob')
                .subscribe((file: any) => {
                    const headers = new HttpHeaders();
                    const headerFileName = headers['x-filename'];

                    const linkElement = document.createElement('a');
                    try {
                        const blob = new Blob([file], { type: type });
                        const urlLink = window.URL.createObjectURL(blob);

                        linkElement.setAttribute('href', urlLink);
                        linkElement.setAttribute('download', headerFileName || fileName);

                        const clickEvent = new MouseEvent('click', {
                            'view': window,
                            'bubbles': true,
                            'cancelable': false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    } catch (ex) {
                        observer.error(ex);
                        observer.complete();
                    }
                    observer.next(true);
                    observer.complete();
                }, error => {
                    observer.error(error);
                    observer.complete();
                });
        });

    }

    private downloadPdf(url: string = "", fileName: string = 'doc.pdf', request: any = {}) {
        return this.http.post(url, request, { responseType: 'blob' })
        .pipe(map(response => {
                saveAs(response, fileName);
            }));
    }

    downloadAutoPolicyChange(jobNumber: string) {
        const endpoint = `${environment.server.api.car}/api/Reports/policyChange?JobNumber=${jobNumber}`;
        return this.download(endpoint, `Endoso_${jobNumber}`, 'application/pdf');
    }

    downloadContractorsAttachment(jobNumber: string) {
        const endpoint = `${environment.server.api.car}/api/Reports/contractorsAttachment?JobNumber=${jobNumber}`;
        return this.download(endpoint, `Endoso_${jobNumber}_AnexoContratistas`, 'application/pdf');
    }

    downloadAdditionalInsured(jobNumber: string, inciso: string = '1') {
        const endpoint = `${environment.server.api.portalpasProxy}/reports-integration/api/AdditionalInsured`;
        const fileName = `Coparticipante_Contratista_${jobNumber}.pdf`;
        const request = {
            clauses: 0,
            inciso: inciso,
            endorsement: this.policyService.getEndorsementByJobNumber(jobNumber),
            policyNumberBranchOffice: this.policyService.getPolicyNumberByJobNumber(jobNumber)
        }
        

        return this.downloadPdf(endpoint, fileName, request);
    }

    downloadEndorsement(jobNumber: string, inciso: string = '1') {
        const endpoint = `${environment.server.api.portalpasProxy}/reports-integration/api/Endorsement`;
        const fileName = `${jobNumber}.pdf`;
        const request = {
            clauses: 0,
            inciso: inciso,
            endorsement: this.policyService.getEndorsementByJobNumber(jobNumber),
            policyNumberBranchOffice: this.policyService.getPolicyNumberByJobNumber(jobNumber)
        }
        

        return this.downloadPdf(endpoint, fileName, request);
    }



}
